// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only.

/**
 * Wave-1 #26 (pharmacy ask): a PA-pending Rx is a normal enrollment anchor, so the persisted
 * carerx_therapy.anchor_warning must not show its PA cause. The server keeps writing it (audit
 * record, CareRxEnrollmentDoorFunctions create path) as ONE string:
 *   "Anchor violation — " + causes joined by "; " + "."
 * with the causes "PA not approved at enrollment (claim: …)" and
 * "drug not matched in Drug Reference at enrollment". There is no structured cause column, so the
 * parse lives here, once: drop the PA cause, keep every other cause, and pass any text that is not
 * in that shape through untouched (an unknown warning is never hidden).
 */
const PREFIX = 'Anchor violation — '
const PA_CAUSE = 'PA not approved at enrollment'

export function visibleAnchorWarning(raw: string | null | undefined): string | null {
  const text = raw?.trim()
  if (!text) return null
  if (!text.startsWith(PREFIX)) return text
  const causes = text.slice(PREFIX.length).replace(/\.$/, '').split('; ')
  const kept = causes.filter(c => !c.startsWith(PA_CAUSE))
  if (kept.length === causes.length) return text
  return kept.length === 0 ? null : `${PREFIX}${kept.join('; ')}.`
}
